<template>
  <div
    class="Container"
    :data-margin="matchEntities(['NETHERLANDS', 'POLAND'])"
  >
    <FindStationScreen />
    <ArrivingToStation />
    <ChargePointTutorial v-if="!matchEntities(['NETHERLANDS', 'POLAND'])" />
  </div>
</template>

<script>
import FindStationScreen from '@/components/ExperiencePage/FindStationScreen.vue';
import ArrivingToStation from '@/components/ExperiencePage/ArrivingToStation/ArrivingToStation.vue';
import ChargePointTutorial from '@/components/ExperiencePage/ChargePointTutorial/ChargePointTutorial.vue';
import matchEntities from '../shared/entityHelpers';

export default {
  components: {
    FindStationScreen,
    ArrivingToStation,
    ChargePointTutorial,
  },
  methods: {
    matchEntities,
  },
};
</script>

<style scoped>
.Container {
  padding-top: 4rem;
}
.Container[data-margin='true'] {
  margin-bottom: 100px;
}
@media (min-width: 768px) {
  .Container {
    padding-top: 8rem;
  }
  .Container[data-margin='true'] {
    margin-bottom: 265px;
  }
}
/* FIXME(greg): only a quick fix for large screens.
   The best approach would be to have a design that accounts
   for larger screens. */
@media (min-width: 2440px) {
  .Container {
    max-width: 2400px;
    margin-right: auto;
    margin-left: auto;
  }
}
</style>
